<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container">
      <form action="" @submit.prevent="saveRecord">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-1">Редактирование</h4>
          </div>
          <div class="card-body">
            <slot/>
            <div class="row">
              <div class="col-md-6">
                <label for="">Запись для редактирования</label>
                <multiselect
                  ref="selectRecord"
                  v-model="selectedSavedOption"
                  @input="(e) => selectedOption = {...e}"
                  :options="modalData.details"
                  placeholder="Выберите запись"
                  track-by="name"
                  label="name"
                  :allow-empty="true"
                  :showLabels="true"
                  :searchable="true"
                  :multiple="false"/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Наименование</label>
                  <textarea rows="2" required class="form-control" v-model="selectedOption.name"/>
                </div>
                <div class="text-right">
                  <button type="button" @click="newRecord" class="btn btn-sm btn-outline-success">Новая запись</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <div class="btn-group" role="group">
              <button @click="() => onClose(false)" class="btn btn-default">
                Отмена
              </button>
              <vue-ladda
                type="submit"
                :disabled="acceptDisabled"
                button-class="btn btn-success"
                @click="() => {}"
                data-style="zoom-in"
                :loading="acceptBtnLoading"
              >Сохранить
              </vue-ladda>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import Multiselect from 'vue-multiselect'
import api from '@/api'

export default {
  components: {
    VueLadda,
    Multiselect
  },
  data() {
    return {
      selectedOption: {
        name: null,
      },
      selectedSavedOption: null,
      acceptBtnLoading: false,
      errorMessage: null
    };
  },
  props: ["onModalClose", "onModalAccept", "modalData", 'acceptDisabled'],
  mounted() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "hidden";
  },
  watch: {
    modalData() {
    }
  },
  beforeDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
  },
  methods: {
    newRecord() {
      this.selectedSavedOption = null;
      // this.$refs.selectRecord.value = null;
      this.selectedOption = {}
    },
    async saveRecord() {
      this.acceptBtnLoading = true;
      const {data} = await api.post('new/projects/updateSelectRecord', {
        type: this.modalData.type,
        project_id: this.modalData.siteId,
        record: this.selectedOption
      })
      if (data.success) {
        toastr['success']('Сохранено');
        this.onModalAccept();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.acceptBtnLoading = true;
    },
    onAccept(e) {
      this.onModalAccept();
    },
    onReject(e) {
      if (!this.acceptBtnLoading) {
        this.onModalClose();
      }
    },
    onClose(e) {
      if (
        !e ||
        (!this.acceptBtnLoading &&
          e.target.id === "modal_wrap")
      ) {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.onModalClose(true);
      }
    }
  }
};
</script>

<style scoped>
.card-body {
  min-height: 300px;
}

.btn-xs {
  font-size: 12px;
  padding: 1px 8px !important;
  margin: 0;
  margin-bottom: 5px;
}

.modal_container {
  max-height: 80%;
  overflow: hidden;
  /*overflow-y: auto;*/
  /*min-width: 50%;*/
  width: 85%;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}
</style>
